// src/components/icons/VybeIcon.tsx
import * as React from "react";

type Props = {
  size?: number;
  strokeWidth?: number;
  className?: string;
};

export default function VybeIcon({
  size = 24,
  strokeWidth = 2,
  className = "",
}: Props) {
  const id = React.useId(); // unique gradient id per instance
  const gradId = `vybeGradient-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={`url(#${gradId})`}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FF3148" />
          <stop offset="100%" stopColor="#00D1FF" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="9" />
      <path d="M8 9.5l4 7 4-7" />
    </svg>
  );
}
